// Tiny formatting + date helpers used across the app.

/** Today as YYYY-MM-DD in local time. */
export function today(): string {
  return toDateStr(new Date());
}

/** Format a Date as YYYY-MM-DD (local). */
export function toDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
}

/** A date N days after the given YYYY-MM-DD (N may be negative). */
export function addDays(dateStr: string, n: number): string {
  const d = new Date(dateStr + "T12:00:00");
  d.setDate(d.getDate() + n);
  return toDateStr(d);
}

/**
 * The Saturday on or before the given date (the start of its operational week).
 * Weeks run Saturday → Friday.
 */
export function startOfWeekSat(dateStr: string): string {
  const dow = new Date(dateStr + "T12:00:00").getDay(); // 0=Sun..6=Sat
  const daysSinceSat = (dow + 1) % 7; // Sat->0, Sun->1, … Fri->6
  return addDays(dateStr, -daysSinceSat);
}

/** Integer with thousands separators. fmtN(12345) === "12,345" */
export function fmtN(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return "0";
  return Math.round(n).toLocaleString("en-US");
}

/**
 * Platform-wide full date: MM-DD-YYYY (month-first). Parses the YYYY-MM-DD string
 * directly (no Date object) so it never shifts by timezone.
 * fmtDate("2026-06-15") === "06-15-2026"
 */
export function fmtDate(dateStr: string | null | undefined): string {
  if (!dateStr) return "—";
  const [y, m, d] = dateStr.split("-");
  if (!y || !m || !d) return dateStr;
  return `${m}-${d}-${y}`;
}

/** Compact month-first date for dense grids: M/D (no zero-pad). fmtMD("2026-09-04") === "9/4" */
export function fmtMD(dateStr: string): string {
  const [, m, d] = dateStr.split("-");
  if (!m || !d) return dateStr;
  return `${Number(m)}/${Number(d)}`;
}

/** Compact weekday + month-first date for day columns. fmtDow("2026-09-04") === "Fri 9/4" */
export function fmtDow(dateStr: string): string {
  const wd = new Date(dateStr + "T12:00:00").toLocaleDateString("en-US", { weekday: "short" });
  return `${wd} ${fmtMD(dateStr)}`;
}
